import { useId } from "react";
import { Fire, Kortkamp, Monopoly, Slagskibe, Speedrun } from "./gameart/scenes1";
import { Kryds, Quizduel, Skak, Skattejagt, Taarn, Videnraes } from "./gameart/scenes2";
import { Ludo, Sudoku, Verden as VerdenScene, Videnspar as VidenSparScene, Yatzy } from "./gameart/scenes3";
import type { SceneProps } from "./gameart/prims";

/**
 * One hand-drawn illustration per game (plain SVG, 640×360, three layers that can move a little against each other).
 * The picture is the "resting" look of a game tile; the video takes over only while the pointer is on the tile.
 */
const SCENES: Record<string, (p: SceneProps) => any> = {
  monopoly: Monopoly,
  kortkamp: Kortkamp,
  slagskibe: Slagskibe,
  speedrun: Speedrun,
  fire: Fire,
  skak: Skak,
  kryds: Kryds,
  quizduel: Quizduel,
  videnraes: Videnraes,
  taarn: Taarn,
  skattejagt: Skattejagt,
  ludo: Ludo,
  yatzy: Yatzy,
  sudoku: Sudoku,
  videnspar: VidenSparScene,
  verden: VerdenScene,
};

export const hasGameArt = (game: string) => game in SCENES;

export function GameArt({ game, className = "", title, fit = "slice" }: { game: string; className?: string; title?: string; fit?: "slice" | "meet" }) {
  const Scene = SCENES[game];
  const u = "ga" + useId().replace(/[^a-zA-Z0-9]/g, "");
  if (!Scene) return null;
  return (
    <svg className={`gameart ${className}`.trim()} viewBox="0 0 640 360" preserveAspectRatio={fit === "slice" ? "xMidYMid slice" : "xMidYMid meet"} role={title ? "img" : undefined} aria-label={title} aria-hidden={title ? undefined : true} focusable="false">
      <Scene u={u} />
    </svg>
  );
}
